import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ["nameField"]

  updateName(event) {
    this.nameFieldTarget.value = event.target.value
  }
}
